import { render, staticRenderFns } from "./RelPapeSantander.vue?vue&type=template&id=16177a0a&scoped=true"
import script from "./RelPapeSantander.vue?vue&type=script&lang=js"
export * from "./RelPapeSantander.vue?vue&type=script&lang=js"
import style0 from "./RelPapeSantander.vue?vue&type=style&index=0&id=16177a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16177a0a",
  null
  
)

export default component.exports